import React, { useState } from 'react';
import styled from '@emotion/styled';
import closeIcon from '../../../../../Assets/Icons/close.svg';
import Icon from '../../../../../Components/Icon';

const Wrapper = styled.div`
  position: relative;
  right: -28px;
  z-index: 2;

  @media (orientation: landscape) {
    right: 0;
  }
`;

const IconWrapper = styled.div`
  background: rgb(255, 255, 255);
  border-radius: 30px;
  border: 1px solid rgb(189, 189, 192);
  height: 80px;
  width: 80px;

  @media (orientation: landscape) {
    height: 60px;
    width: 60px;
    border-radius: 22px;
  }
`;

const InfoIcon = styled.div`
  color: rgb(19, 19, 22);
  font-family: Eina01-Light;
  font-size: 48px;
  font-weight: 300;
  text-align: center;

  @media (orientation: landscape) {
    font-size: 39px;
  }
`;

const Popup = styled.div<{ visible: boolean }>`
  position: absolute;
  z-index: 1;
  right: 0;
  top: 0;
  background: rgb(255, 255, 255);
  border-radius: 30px;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14),
    0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  width: 448px;
  padding: 60px 32px;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: 0.3s visibility, 0.3s opacity;

  @media (orientation: landscape) {
    border-radius: 22px;
  }
`;

const Title = styled.div`
  color: rgb(33, 33, 36);
  font-family: Eina01-SemiBold;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.19px;
  line-height: 32px;
`;

const Description = styled.div`
  color: rgb(33, 33, 36);
  font-family: Eina01-Regular;
  font-size: 16px;
  letter-spacing: 0.24px;
  line-height: 20px;
`;

const CloseIcon = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;

  @media (orientation: landscape) {
    top: 10px;
    right: 10px;
  }
`;

export interface Props {
  description: string;
}

const Info = ({ description }: Props) => {
  const [visible, setVisible] = useState(false);

  return (
    <Wrapper>
      <IconWrapper onClick={() => setVisible(true)}>
        <InfoIcon>i</InfoIcon>
      </IconWrapper>
      <Popup visible={visible}>
        <CloseIcon onClick={() => setVisible(false)}>
          <Icon icon={closeIcon} color={'#131316'} size={40} />
        </CloseIcon>
        <Title>Description</Title>
        <Description>
          <p>{description}</p>
        </Description>
      </Popup>
    </Wrapper>
  );
};

export default Info;
